// extracted by mini-css-extract-plugin
module.exports = {"content":"content_content__1lj7O","inline":"content_inline__2QQKh"};